import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@woolworthsnz/form';
import { FulfilmentLibModule } from '@woolworthsnz/fulfilment';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import {
	AddDeliveryAddressModalComponent,
	ChangeDeliveryAddressModalComponent,
	ChangePickupStoreModalComponent,
	FeesModalComponent,
} from './components';
import { HowWhereWhenRoutingModule } from './how-where-when-routing.module';
import { HowWhereWhenPage } from './pages/how-where-when/how-where-when.page';
import { DeliverySaverTagComponent } from './components/delivery-saver-tag/delivery-saver-tag.component';
import { DirectToBootModalComponent } from './components/direct-to-boot-modal/direct-to-boot-modal.component';
import { DualOfferModalComponent } from './components/dual-offer-modal/dual-offer-modal.component';
import { DirectToBootGroupedModalComponent } from './components/direct-to-boot-grouped-modal/direct-to-boot-grouped-modal.component';
import { CoreModule } from '../core/core.module';
import { ExpressFeesModalComponent } from './components/express-fee-modal/express-fees-modal.component';
import { FlexibleDeliveryFeesModalComponent } from './components/flexible-delivery-fee-modal/flexible-delivery-fees-modal.component';
import { ChangeFlexibleSlotModalComponent } from './components/change-flexible-slot-modal/change-flexible-slot-modal.component';

@NgModule({
	imports: [
		CoreModule,
		CommonModule,
		FormModule,
		FormsModule,
		FulfilmentLibModule,
		HowWhereWhenRoutingModule,
		OverlayModule,
		PortalModule,
		ReactiveFormsModule,
		StyleguideModule.forRoot(),
		HowWhereWhenPage,
		AddDeliveryAddressModalComponent,
		ChangeDeliveryAddressModalComponent,
		ChangePickupStoreModalComponent,
		FeesModalComponent,
		ExpressFeesModalComponent,
		DeliverySaverTagComponent,
		DirectToBootModalComponent,
		DualOfferModalComponent,
		DirectToBootGroupedModalComponent,
		FlexibleDeliveryFeesModalComponent,
		ChangeFlexibleSlotModalComponent,
	],
})
export class HowWhereWhenModule {}
